import Box from "@mui/material/Box";
import { alpha } from "@mui/material/styles";
import StatusDot from "./StatusDot";
import {
  CATALOGUE_CHIP_HEIGHT,
  CHIP_TINT_OPACITY,
  CatalogueStatus,
} from "./constants";

interface StatusPillProps {
  status: CatalogueStatus | null;
}

/** Tinted, rounded version of StatusDot used in the product / pricebook detail headers. */
export default function StatusPill({ status }: StatusPillProps) {
  const isEnabled = status !== "disable";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: CATALOGUE_CHIP_HEIGHT,
        borderRadius: 4,
        fontWeight: 600,
        color: (theme) =>
          isEnabled ? theme.palette.success.main : theme.palette.error.main,
        bgcolor: (theme) =>
          alpha(
            isEnabled ? theme.palette.success.main : theme.palette.error.main,
            CHIP_TINT_OPACITY,
          ),
      }}
    >
      <StatusDot status={status} />
    </Box>
  );
}
